import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

import { LIFECYCLE_REGEXP } from '../constants';

export const sharedSelectors = getSelectors(adminPageNames.SL_ACCOUNTS);

export const slAccountsSelector = ({ administration }) => administration[adminPageNames.SL_ACCOUNTS].slAdminAccounts;

export const slViewOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.SL_ACCOUNTS].slViews,
  slViews => slViews.map(({ name, value }) => ({ label: name, value }))
);

export const lifecycleMapOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.SL_ACCOUNTS].slAccounts,
  slAccounts => slAccounts
    .filter(({ slAccount }) => LIFECYCLE_REGEXP.test(slAccount))
    .map(({ slAccount }) => ({ label: slAccount, value: slAccount }))
);

export const isFetchingInitialDataForModalSelector = ({ administration }) =>
  administration[adminPageNames.SL_ACCOUNTS].isFetchingInitialDataForAddAndEditModal;
